import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { Document, Partner, Share, SharesTitle } from 'types';
import EmptyStateForTable from 'modules/_shared/components/EmptyStates/EmptyStateForTable';
import PartnerSharesTableHeader from './PartnerSharesTableHeader';
import PartnerSharesTableBody from './PartnerSharesTableBody';
import PartnerSharesTableFooter from './PartnerSharesTableFooter';
import { getSharesCountTotal } from '../utils/getSharesCountTotal';

type PartnerSharesTableProps = {
  currentPage: number;
  fetchPartnerData: () => void;
  hasSharesTitlesEnabled: boolean;
  isAdmin: boolean;
  isCoOwner?: boolean;
  partnerId: string;
  rowsPerPage: number;
  shares: Share[];
  sharesTitles: SharesTitle[];
  societySharesTitleDocument?: Document;
  societySharesTitleDocumentWithCoOwners?: Document;
};

const PartnerSharesTable: FC<PartnerSharesTableProps> = ({
  currentPage,
  fetchPartnerData,
  hasSharesTitlesEnabled,
  isAdmin,
  isCoOwner,
  partnerId,
  rowsPerPage,
  shares,
  sharesTitles,
  societySharesTitleDocument,
  societySharesTitleDocumentWithCoOwners,
}: PartnerSharesTableProps) => {
  const { t } = useTranslate();

  const sharesCountTotal = getSharesCountTotal(shares);
  const showEncumbranceColumn = isAdmin && !isCoOwner;
  const showSharesTitleColumn = hasSharesTitlesEnabled && isAdmin && !isCoOwner;

  return (
    <>
      <table className="table table-striped table-font-sm">
        <PartnerSharesTableHeader
          isCoOwner={isCoOwner}
          showEncumbranceColumn={showEncumbranceColumn}
          showSharesTitleColumn={showSharesTitleColumn}
        />
        {shares?.length > 0 ? (
          <>
            <PartnerSharesTableBody
              currentPage={currentPage}
              fetchPartnerData={fetchPartnerData}
              isCoOwner={isCoOwner}
              partnerId={partnerId}
              rowsPerPage={rowsPerPage}
              shares={shares}
              sharesTitles={sharesTitles}
              showEncumbranceColumn={showEncumbranceColumn}
              showSharesTitleColumn={showSharesTitleColumn}
              societySharesTitleDocument={societySharesTitleDocument}
              societySharesTitleDocumentWithCoOwners={
                societySharesTitleDocumentWithCoOwners
              }
            />
            <PartnerSharesTableFooter sharesCountTotal={sharesCountTotal} />
          </>
        ) : (
          <EmptyStateForTable
            mainMessage={t('ThisPartnerHasNoShares')}
            infoMessage=""
            colspan={7}
          />
        )}
      </table>
    </>
  );
};

export default PartnerSharesTable;
